export default __webpack_public_path__ + "static/media/saleshandy.3508f3bd.svg";